import { render, staticRenderFns } from "./TaxesValuesTable.vue?vue&type=template&id=76c2a639&scoped=true&"
import script from "./TaxesValuesTable.vue?vue&type=script&lang=js&"
export * from "./TaxesValuesTable.vue?vue&type=script&lang=js&"
import style0 from "./TaxesValuesTable.vue?vue&type=style&index=0&id=76c2a639&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c2a639",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
